export const security = {
  tokens: {
    core: "",
    generic: "",
    security: "",
    miApp: "",
    gateway: "",
    notification: "",
    integration: "",
  },
};
